if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal')) {
          this.remove();
          return;
        }

        this.formId = this.dataset.formId || this.closest('form')?.id;
        this.form = this.formId ? document.getElementById(this.formId) : this.closest('form');
        this.primarySubmitButton = this.form?.querySelector('.product-form__submit');
        this.templateButton = this.querySelector('.sf-sticky-buy-bar__button');
        this.defaultLabel = this.dataset.defaultLabel || 'Buy it now';
        this.mainContent = document.getElementById('MainContent');

        if (!this.form || !this.formId || !this.primarySubmitButton || !this.templateButton) {
          this.remove();
          return;
        }

        this.mountPortal();

        this.boundSyncState = this.syncState.bind(this);
        this.boundScheduleSync = () => window.requestAnimationFrame(this.boundSyncState);

        this.form.addEventListener('change', this.boundScheduleSync);
        this.form.addEventListener('input', this.boundScheduleSync);
        window.addEventListener('resize', this.boundScheduleSync, { passive: true });

        this.primarySubmitObserver = new MutationObserver(() => this.boundScheduleSync());
        this.primarySubmitObserver.observe(this.primarySubmitButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        this.updateOffset();
        this.syncState();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('change', this.boundScheduleSync);
        this.form?.removeEventListener('input', this.boundScheduleSync);
        window.removeEventListener('resize', this.boundScheduleSync);
        this.primarySubmitObserver?.disconnect();
        this.portal?.remove();
        if (this.mainContent) {
          this.mainContent.style.paddingBottom = '';
        }
      }

      syncState() {
        if (!this.portalButton || !this.form?.isConnected) {
          this.portal?.remove();
          return;
        }

        const primaryLabel = this.primarySubmitButton.querySelector('span')?.textContent?.trim();
        const variantId = this.form.querySelector('input[name="id"]')?.value;
        const isDisabled =
          !variantId ||
          this.primarySubmitButton.hasAttribute('disabled') ||
          this.primarySubmitButton.getAttribute('aria-disabled') === 'true';

        this.portalButton.disabled = isDisabled;

        if (isDisabled) {
          this.portalButton.setAttribute('aria-disabled', 'true');
          this.portalButton.querySelector('span').textContent = primaryLabel || this.defaultLabel;
        } else {
          this.portalButton.removeAttribute('aria-disabled');
          this.portalButton.querySelector('span').textContent = this.defaultLabel;
        }

        this.updateOffset();
      }

      updateOffset() {
        if (!this.portal) return;

        const height = Math.ceil(this.portal.getBoundingClientRect().height || 0);
        if (this.mainContent) {
          this.mainContent.style.paddingBottom = `${height + 16}px`;
        }
      }

      mountPortal() {
        const existingPortal = document.querySelector(
          `.sf-sticky-buy-bar-portal[data-form-id="${this.formId}"]`
        );
        if (existingPortal) {
          existingPortal.remove();
        }

        this.portal = document.createElement('div');
        this.portal.className = 'sf-sticky-buy-bar-portal';
        this.portal.dataset.formId = this.formId;

        this.portalButton = this.templateButton.cloneNode(true);
        this.portalButton.setAttribute('form', this.formId);
        this.portal.appendChild(this.portalButton);
        document.body.appendChild(this.portal);
      }
    }
  );
}
